/**
 * Initiated By Field Component
 * Dropdown for filtering by who triggered a sync
 * Includes static options (All, System, Manual) and dynamic user options
 */

import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'

interface InitiatedByFieldProps {
  value: string
  onChange: (value: string) => void
  initiatorOptions: string[]
  loading?: boolean
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const InitiatedByField: React.FC<InitiatedByFieldProps> = ({
  value,
  onChange,
  initiatorOptions,
  loading = false,
  label = 'Initiated By',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select
          displayEmpty
          value={value}
          onChange={handleChange}
          disabled={loading}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="system">System (Auto)</MenuItem>
          <MenuItem value="manual">Manual (User)</MenuItem>
          {initiatorOptions.length > 0 && (
            <MenuItem disabled sx={{ borderTop: 1, borderColor: 'divider', mt: 0.5, pt: 0.5 }}>
              <Typography variant="caption" color="textSecondary">
                Individual Users
              </Typography>
            </MenuItem>
          )}
          {initiatorOptions.map(email => (
            <MenuItem key={email} value={email}>
              {email}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default InitiatedByField
